/* eslint consistent-return: 0 */
import { useLayoutEffect, useRef } from 'react';

var useUpdateLayoutEffect = function useUpdateLayoutEffect(effect, deps) {
  var isMounted = useRef(false);
  useLayoutEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    } else {
      return effect();
    }
  }, deps);
};

export default useUpdateLayoutEffect;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useUpdateLayoutEffect/index.js
// module id = 7519
// module chunks = 2